<template>
	<div class="bg">
		<span class="close" @click="$emit('close')">✖</span>
		<div class="video-modal modal">
			<video autoplay controls ref="video">
				<source v-bind="primaryVideoFile" />
				<source :src="video.mp4" type="video/mp4" />
				<source :src="video.ogg" type="video/ogg" />
				Your browser does not support the video tag.
			</video>
		</div>
	</div>
</template>

<script>
export default {
	name: 'game-video',
	props: ['video'],
	computed: {
		primaryVideoFile() {
			const androidVersion = navigator.userAgent.match(/Android (\d+(?:\.\d+)*);/)

			const isOldMobile = androidVersion && parseFloat(androidVersion[1]) < 11

			// if(androidVersion) {
			// 	console.log(androidVersion)
			// 	console.log(parseFloat(androidVersion[1]))
			// }

			return isOldMobile ? {src: this.video.mp4, type: "video/mp4"} : {src: this.video.webm, type: "video/webm"}
		}
	},
	mounted() {
		this.$refs.video.play()
	},
}
</script>

<style scoped>
.bg {
	width: 100vw;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.8);

	z-index: 90;
}
.video-modal {
	display: block !important;
	/* overflow: hidden; */
	transition: opacity 0.3s ease;
	height: 720px;
	width: 960px;
	padding: 10px;
	background: #ffffff;
	border: 1px solid #333;
	border-radius: 5px;
	position: absolute;
	left: calc(50% - 480px);
	top: calc(50% - 360px);
}

video {
	width: 100%;
	height: 100%;
}

.close {
	right: 20px;
	top: 20px;
	position: absolute;
	font-size: 35px;
	color: #ffffff;
	cursor: pointer;
}

@media (max-width: 991px) {
	.video-modal {
		height: 480px;
		width: 640px;
		left: calc(50% - 320px);
		top: calc(50% - 240px);
	}
}

@media (max-width: 768px) {
	.video-modal {
		height: 360px;
		width: 480px;
		left: calc(50% - 240px);
		top: calc(50% - 180px);
	}
}

@media (max-width: 568px) {
	.video-modal {
		height: 240px;
		width: 320px;
		left: calc(50% - 160px);
		top: calc(50% - 120px);
	}
}
</style>
